import React from "react";
import { Dropdown } from "react-bootstrap";
import { FaEllipsisV } from "react-icons/fa";
import "./TableCustomizer.css";

// ── The three-dot table menu ──────────────────────────────────────────────────
//
// Sits at the right-hand end of a listing's action row, next to "Clear all
// Filters". Holds the per-table view options rather than the per-row actions, so
// it stays out of the way of the buttons people press constantly.
//
//   <TableCustomizerMenu {...menuProps} />   // menuProps from useCustomizableColumns
//
// `as="span"` on the toggle: the default renders a <button>, which inside a
// Bootstrap form row picks up button sizing and a focus ring sized for a real
// button. A span with the toggle role keeps it a plain icon.
export default function TableCustomizerMenu({
  onCustomize,
  onReset,
  isCustomized = false,
  disabled = false,
  align = "end",
  label = "Table options",
}) {
  return (
    <Dropdown align={align} className="tc-menu">
      <Dropdown.Toggle
        as="span"
        role="button"
        tabIndex={disabled ? -1 : 0}
        className={`tc-menu-toggle${disabled ? " tc-menu-toggle-disabled" : ""}`}
        aria-label={label}
        title={label}
        // Bootstrap's caret is a ::after on the toggle; there is no prop to drop
        // it, so the class removes it and the icon stands alone.
      >
        <FaEllipsisV />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item disabled={disabled} onClick={onCustomize}>
          Customize Table
        </Dropdown.Item>
        {/* Nothing to reset until something is stored, so the item only appears
            once the user actually has a saved layout. */}
        {isCustomized && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item disabled={disabled} className="text-danger" onClick={onReset}>
              Reset to default columns
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
